import React, { ReactNode } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface InputFieldProps {
  label?: string;
  placeholder?: string;
  type: string;
  // name?: string;
  register?: UseFormRegisterReturn;
  error?: any;
  accpect?: any;
  inputClass?: string;
  multiple?: string;
  disabled?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  placeholder,
  type,
  // name,
  register,
  error,
  accpect,
  inputClass,
  disabled,
}) => {
  return (
    <div className="w-full">
      <label className="block text-gray-700">{label}</label>
      <input
        type={type}
        disabled={disabled}
        {...register}
        onWheel={(e) => {
          if (type === "number") {
            e.currentTarget.blur(); // temporarily removes focus to prevent scroll
          }
        }}
        placeholder={placeholder}
        accept={accpect && accpect}
        className={`w-full p-2 mt-2 border text-sm placeholder:text-gray-400 h-11 rounded-lg focus:outline-none caret-darkCyan ${inputClass}`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default React.memo(InputField);
